/**
 * Fired synchronously from `CanvasContext`'s delete path, before storage is
 * touched, so listeners can read the nodes that are about to go.
 *
 * The comment pin layer listens; it mounts only for users who can comment, so
 * a canvas without comments pays nothing — a hook in `CanvasContext` would
 * subscribe every viewer (and every thumbnail capture) to the room's threads.
 */
export const CANVAS_NODES_DELETED_EVENT = "canvas:nodes-deleted";

export function emitCanvasNodesDeleted(nodeIds: string[]) {
  if (nodeIds.length === 0) return;
  window.dispatchEvent(
    new CustomEvent(CANVAS_NODES_DELETED_EVENT, { detail: { nodeIds } }),
  );
}
